import React, { useState, useEffect } from "react";
import "./AnimationToggle.css";

const AnimationToggle = () => {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    // Check user's system preference
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      setReduced(true);
      document.body.classList.add('reduce-motion');
    }
  }, []);

  const toggleAnimations = () => {
    const newValue = !reduced;
    setReduced(newValue);
    
    if (newValue) {
      document.body.classList.add('reduce-motion');
    } else {
      document.body.classList.remove('reduce-motion');
    }
  };

  return (
    <div className="animation-toggle">
      <button 
        onClick={toggleAnimations}
        className={`toggle-button ${reduced ? 'active' : ''}`}
        aria-label={reduced ? "Activer les animations" : "Réduire les animations"}
        title={reduced ? "Activer les animations" : "Réduire les animations"}
      >
        <svg 
          width="20" 
          height="20" 
          viewBox="0 0 20 20" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {reduced ? (
            // Play icon
            <path 
              d="M5 3L16 10L5 17V3Z" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          ) : (
            // Pause icon
            <>
              <rect x="5" y="3" width="3" height="14" fill="currentColor" />
              <rect x="12" y="3" width="3" height="14" fill="currentColor" />
            </>
          )}
        </svg>
        <span className="toggle-label">
          {reduced ? "Animations désactivées" : "Animations actives"}
        </span>
      </button>
    </div>
  );
};

export default AnimationToggle;
